/* Biomarker-Übersicht — Phase 4, Teil C. Stand 07.08.2026.
   Gehört zu sections/biomarker-uebersicht.liquid.
   Daten aus assets/biomarker-daten.js (window.ORY_BIOMARKER).

   DREI DINGE, DIE HIER ABSICHTLICH FEHLEN
   1. Prozentzahlen — erzeugte Werte, stehen auf der Anwaltsliste.
      Analysen sind nach Preis aufsteigend sortiert.
   2. Referenzbereiche — stehen nicht in den Daten und werden nicht
      erfunden. Stattdessen ein Satz je Seite.
   3. Kofaktoren und verwandte Werte — vorbereitet, nicht Teil dieses Baus.

   Die Kaskade wurde bis 05.10.2026 vom Endpunkt /api/cascade nachgeladen
   (alte, ungeprüfte Texte, nur Deutsch). Seitdem verlinkt jede Karte ihre
   geprüfte Kaskaden-Seite auf biomarker.ory-berlin.de (Freigabe der Nutzerin). */
(function () {
  'use strict';

  var wurzel = document.querySelector('.bm');
  if (!wurzel) return;

  // Seit 05.10.2026: englische Fassung unter /en/… — Kartentexte aus m.en
  // (erzeugt aus den Übersetzungen der Biomarker-Seiten), Beschriftungen hier.
  var EN = /^\/en(\/|$)/.test(location.pathname);
  var TEXT_EN = {
    'Wird untersucht bei': 'Examined for',
    'Wird gemessen in einer Analyse': 'Measured in one analysis',
    'Zu diesem Wert ist derzeit keine Analyse im Sortiment hinterlegt.': 'No analysis for this value is currently listed in the shop.',
    'Wie hängt das zusammen?': 'How does it fit together?',
    'Mehr erfahren': 'Learn more',
    'Auch gesucht als: ': 'Also searched as: ',
    'Kein Treffer': 'No match', 'Ein Treffer': 'One match', ' Treffer': ' matches',
    'Bestellbar über den Testkatalog': 'Available to order via the test catalogue',
    'Referenzbereiche und Einordnung findest du in deinem Befund.': 'Reference ranges and interpretation are given in your report.',
    'Die genannten Anlässe sind Beispiele, keine Diagnose. Wenn dich Beschwerden beunruhigen, sprich mit einer Ärztin oder einem Arzt.': 'The occasions listed are examples, not a diagnosis. If symptoms worry you, talk to a doctor.'
  };
  function T(de) { return EN && TEXT_EN[de] ? TEXT_EN[de] : de; }
  function F(m, feld) { return EN && m.en && m.en[feld] && (!Array.isArray(m.en[feld]) || m.en[feld].length) ? m.en[feld] : m[feld]; }
  function pfadLokal(p) { return (EN ? '/en' : '') + p; }

  function bereit() {
    var D = window.ORY_BIOMARKER;
    if (!D || !D.seiten) { melden('Die Daten konnten nicht geladen werden.'); return; }
    var seite = D.seiten.filter(function (s) { return s.handle === wurzel.dataset.seite; })[0];
    if (!seite) { melden('Für diese Seite gibt es keine Daten (' + wurzel.dataset.seite + ').'); return; }
    aufbauen(D, seite);
  }

  function melden(text) {
    var l = wurzel.querySelector('[data-bm-liste]');
    if (l) l.innerHTML = '<p class="bm__laedt">' + text + '</p>';
  }

  function el(tag, klasse, text) {
    var e = document.createElement(tag);
    if (klasse) e.className = klasse;
    if (text != null) e.textContent = text;
    return e;
  }

  // ── Aufbau ───────────────────────────────────────────────────────────

  function aufbauen(D, seite) {
    // Fließtext-Abschnitte über den Markern
    var ab = wurzel.querySelector('[data-bm-abschnitte]');
    if (seite.abschnitte && seite.abschnitte.length) {
      seite.abschnitte.forEach(function (a) {
        var k = el('div', 'bm-abschnitt');
        k.appendChild(el('h2', 'bm-abschnitt__titel', a.titel));
        (a.absaetze || []).forEach(function (p) { k.appendChild(el('p', null, p)); });
        if (a.verweis && typeof a.verweis === 'object') k.appendChild(verweisBauen(a.verweis));
        ab.appendChild(k);
      });
      ab.hidden = false;
    }

    var hw = wurzel.querySelector('[data-bm-hinweis]');
    if (seite.hinweis) { hw.textContent = T(seite.hinweis); hw.hidden = false; }

    // Die abklaerungsbeduerftigen Warnzeichen bleiben als Anlass stehen —
    // dafuer liefert dieser Satz die Einordnung mit. Die akuten Zeichen
    // erscheinen gar nicht erst (Entscheidung 07.08.2026).
    var ah = wurzel.querySelector('[data-bm-anlasshinweis]');
    if (ah && seite.anlaesseHinweis) { ah.textContent = T(seite.anlaesseHinweis); ah.hidden = false; }

    var liste = wurzel.querySelector('[data-bm-liste]');
    liste.innerHTML = '';
    seite.bloecke.forEach(function (b) {
      liste.appendChild(b.art === 'gruppe' ? gruppeBauen(b, D) : markerBauen(b, D));
    });

    suche(seite, liste);
    vorauswahl(liste);
  }

  // Verweis unter einem Abschnitt: { text, linktext, ziel }. Bis 02.10.2026
  // stand hier ein Redaktionsauftrag als Klartext und wurde wörtlich
  // angezeigt — ein blosser String wird deshalb nicht mehr ausgegeben.
  function verweisBauen(v) {
    var p = el('p', 'bm-abschnitt__verweis');
    if (v.text) p.appendChild(document.createTextNode(v.text + ' '));
    if (v.ziel && v.linktext) {
      var a = el('a', null, v.linktext + ' →');
      a.href = (/^\/en(\/|$)/.test(location.pathname) ? '/en' : '') + v.ziel;
      p.appendChild(a);
    }
    return p;
  }

  function gruppeBauen(g, D) {
    var k = el('div', 'bm-gruppe');
    k.appendChild(el('h2', 'bm-gruppe__titel', g.titel));
    if (g.hinweis) k.appendChild(el('p', 'bm-gruppe__hinweis', g.hinweis));
    g.marker.forEach(function (m) { k.appendChild(markerBauen(m, D, true)); });
    k.dataset.suchtext = suchtext(g.marker.map(function (m) { return m; }), g.titel);
    return k;
  }

  function markerBauen(m, D, inGruppe) {
    var k = el(inGruppe ? 'div' : 'article', 'bm-marker');
    k.id = 'bm-' + kennung(m.name);
    k.dataset.name = m.name;
    if (!inGruppe) k.dataset.suchtext = suchtext([m]);

    k.appendChild(el(inGruppe ? 'h3' : 'h2', 'bm-marker__titel', F(m, 'titel')));
    if (F(m, 'unterzeile')) k.appendChild(el('p', 'bm-marker__unterzeile', F(m, 'unterzeile')));
    if (F(m, 'beschreibung')) k.appendChild(el('p', 'bm-marker__text', F(m, 'beschreibung')));

    // „Wird untersucht bei" entfällt, wenn nach dem Diagnose-Ausschluss
    // nichts übrig bleibt — bei Gesamtcholesterin und Kreatinin ist das so.
    if (m.anlaesse && m.anlaesse.length) {
      k.appendChild(el('p', 'bm-marker__label', T('Wird untersucht bei')));
      var chips = el('div', 'bm-anlaesse');
      F(m, 'anlaesse').forEach(function (a) { chips.appendChild(el('span', 'bm-anlass', a)); });
      k.appendChild(chips);
    }

    if (m.tests && m.tests.length) {
      k.appendChild(el('p', 'bm-marker__label',
        m.tests.length === 1 ? T('Wird gemessen in einer Analyse')
          : EN ? 'Measured in ' + m.tests.length + ' analyses' : 'Wird gemessen in ' + zahlwort(m.tests.length) + ' Analysen'));
      var box = el('div', 'bm-analysen');
      m.tests.forEach(function (t) {
        var z = el('div', 'bm-analyse');
        var a = el('a', 'bm-analyse__name', t.name);
        a.href = pfadLokal('/products/' + t.handle);
        z.appendChild(a);
        z.appendChild(el('span', 'bm-analyse__preis', t.preis));
        box.appendChild(z);
      });
      k.appendChild(box);
    } else if (m.katalog) {
      // Seit 05.10.2026: Werte ohne Shop-Produkt, die im Testkatalog stehen.
      var kat = el('p', 'bm-analyse--fehlt');
      var ka = el('a', null, T('Bestellbar über den Testkatalog') + ' →');
      ka.href = pfadLokal('/pages/testkatalog');
      kat.appendChild(ka);
      k.appendChild(kat);
    } else {
      k.appendChild(el('p', 'bm-analyse--fehlt', T('Zu diesem Wert ist derzeit keine Analyse im Sortiment hinterlegt.')));
    }

    // Aromatogramm ist eine Untersuchung, kein Messwert — der Hinweis
    // steht in der Kategoriendatei und wird hier ausgegeben.
    if (m.darstellung) k.appendChild(el('p', 'bm-marker__unterzeile', m.darstellung));

    var fuss = el('div', 'bm-marker__fuss');
    // Seit 05.10.2026: Link auf die ausführliche Biomarker-Seite.
    if (m.handle) {
      var mehr = el('a', 'bm-mehr button button--secondary', T('Mehr erfahren') + ' →');
      mehr.href = pfadLokal('/pages/' + m.handle);
      fuss.appendChild(mehr);
    }
    // Seit 05.10.2026: Link auf die geprüfte Kaskaden-Seite (biomarker.ory-berlin.de, Schema v2) statt
    // der alten Texte vom Endpunkt /api/cascade. Ohne geprüfte Seite kein Link.
    if (m.kaskadeSeite) {
      var ka = el('a', 'bm-kaskade-knopf button button--secondary', T('Wie hängt das zusammen?') + ' ↗');
      ka.href = D.kaskade + (EN ? 'en/' : '') + 'kaskade/marker/' + m.kaskadeSeite + '.html';
      ka.target = '_blank';
      ka.rel = 'noopener';
      fuss.appendChild(ka);
    }
    k.appendChild(fuss);

    if (m.synonyme && m.synonyme.length) {
      k.appendChild(el('p', 'bm-marker__synonyme', T('Auch gesucht als: ') + F(m, 'synonyme').join(' · ')));
    }
    return k;
  }

  // ── Suche und Vorauswahl ─────────────────────────────────────────────

  function suche(seite, liste) {
    var feld = wurzel.querySelector('[data-bm-suche]');
    var zahl = wurzel.querySelector('[data-bm-zahl]');
    if (!feld) return;
    var karten = [].slice.call(liste.children);
    feld.addEventListener('input', function () {
      var q = feld.value.trim().toLowerCase();
      var n = 0;
      karten.forEach(function (kk) {
        var treffer = !q || (kk.dataset.suchtext || '').indexOf(q) !== -1;
        kk.hidden = !treffer;
        if (treffer) n++;
      });
      // Gezaehlt werden Bloecke, nicht Marker — die Cortisol-Gruppe ist ein
      // Block mit vier Werten. „2 von 8" haette zwei Einheiten gemischt.
      zahl.textContent = q ? (n === 0 ? T('Kein Treffer') : n === 1 ? T('Ein Treffer') : n + T(' Treffer')) : '';
    });
  }

  function vorauswahl(liste) {
    var p = new URLSearchParams(location.search).get('marker');
    if (!p) return;
    var ziel = [].slice.call(liste.querySelectorAll('[data-name]')).filter(function (k) {
      return k.dataset.name.toLowerCase().indexOf(p.toLowerCase()) !== -1;
    })[0];
    if (!ziel) return;
    ziel.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ── Kleinkram ────────────────────────────────────────────────────────

  function suchtext(marker, extra) {
    return (marker.map(function (m) {
      var en = m.en || {};
      return [m.name, m.titel, m.beschreibung, (m.synonyme || []).join(' '), (m.anlaesse || []).join(' '),
              en.titel, en.beschreibung, (en.anlaesse || []).join(' '), (en.synonyme || []).join(' ')].join(' ');
    }).join(' ') + ' ' + (extra || '')).toLowerCase();
  }

  function kennung(name) {
    return name.toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function zahlwort(n) {
    return ['null', 'einer', 'zwei', 'drei', 'vier', 'fünf', 'sechs', 'sieben', 'acht', 'neun', 'zehn'][n] || n;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bereit);
  else bereit();
})();
